<script>
    import { createEventDispatcher } from "svelte";
    import SvelteMarkdown from 'svelte-markdown'
    import Select from "./Select.svelte";

    const celebrations = [
        // {
        //     title: "Breast Cancer Awareness",
        //     borders: [],
        //     description: ``
        // },
        {
            title: "Black History Month",
            borders: [
                { src: "/borders/bhm1.png" },
                // { src: "/borders/bhm2.png" },
                // { src: "/borders/bhm3.png" },
                { src: "/borders/bhm4.png" },
                { src: "/borders/bhm5.png" },
                { src: "/borders/bhm6.png" },
                { src: "/borders/bhm7.png" },
                { src: "/borders/bhm8.png" },
            ],
            description: `**Black History Month** (US) is a commemoration of African American history and achievement that takes places each February in the United States. 
            It is celebrated with a range of events to celebrate, honor, and learn about Black history while paying tribute to the many impactful contributions Black Americans have made.
            Learn more about [Black History Month](https://www.britannica.com/topic/Black-History-Month) on the Britannica website.`
        },
        {
            title: "Diwali",
            borders: [
                { src: "/borders/diwali1.png" },
                { src: "/borders/diwali2.png" },
                { src: "/borders/diwali3.png" },
                { src: "/borders/diwali4.png" },
                { src: "/borders/diwali5.png" },
                { src: "/borders/diwali6.png" },
            ],
            description: `**Diwali** is a major Hindu festival known as the Festival of Lights.
            Celebrating the victory of light over darkness and good over evil, typically marked by lighting lamps, fireworks, and gatherings.
            To learn more about Diwali, you can visit [BBC's Diwali Overview](https://www.bbc.co.uk/bitesize/topics/zh86n39/articles/zjpp92p) for a general introduction, 
            [National Geographic's Diwali Feature](https://www.nationalgeographic.com/history/article/diwali-history-customs-indian-festival-of-lights) for cultural insights and vibrant imagery, 
            or [Britannica's Detailed Article](https://www.britannica.com/topic/Diwali-Hindu-festival) for an in-depth exploration of the festival's origins and traditions.`
        },
        {
            title: "Halloween",
            borders: [
                { src: "/borders/halloween1.png" },
                { src: "/borders/halloween3.png" },
                { src: "/borders/halloween4.png" },
                { src: "/borders/halloween5.png" },
                { src: "/borders/halloween6.png" },
            ],
            description: `**Halloween** is a cultural and religious holiday celebrated on October 31st.
            Characterized by activities such as trick-or-treating, costume parties, carving pumpkins, and visiting haunted attractions, stemming from ancient Celtic harvest festivals and later influenced by Christian traditions. 
            To learn more about Halloween, you can explore [History.com's Halloween page](https://www.history.com/topics/halloween/history-of-halloween) for a detailed history of the holiday, 
            and [National Geographic's Halloween History](https://www.nationalgeographic.com/culture/article/the-history-of-halloween) for insights into its origins and how it's celebrated around the world.`
        },
        {
            title: "Hispanic Heritage",
            borders: [
                { src: "/borders/hispanic1.png" },
                { src: "/borders/hispanic2.png" },
                { src: "/borders/hispanic3.png" },
                { src: "/borders/hispanic4.png" },
            ],
            description: `**Hispanic Heritage Month** is an annual celebration from September 15 to October 15 in the United States.
            Honoring the histories, cultures, and contributions of American citizens with ancestry from Spain, Mexico, the Caribbean, and Central and South America.
            To learn more about Hispanic Heritage Month, you can visit [HispanicHeritageMonth.gov]() for resources and events, 
            and [History.com's Hispanic Heritage Month](https://www.history.com/topics/hispanic-history/hispanic-heritage-month) for historical context and significance.`
        },
        // {
        //     title: "Pride",
        //     borders: [],
        //     description: ``
        // },
        {
            title: "Veterans Day",
            borders: [
                { src: "/borders/vets1.png" },
                { src: "/borders/vets2.png" },
                { src: "/borders/vets3.png" },
                { src: "/borders/vets4.png" },
            ],
            description: `**Veterans Day** is a U.S. federal holiday observed on November 11th, honoring military veterans who have served in the Armed Forces, and it coincides with Armistice Day, marking the end of World War I.
            To learn more about Veterans Day, you can visit [VA.gov's Veterans Day page](https://department.va.gov/veterans-day) for history and observances, [History.com's Veterans Day](https://www.history.com/topics/holidays/history-of-veterans-day) for the background and significance, and [Military.com's Veterans Day](https://www.military.com/veterans-day) for stories and ways to honor veterans.`
        },
    ];

    let selectedBorderImage = null;
    let selectedCelebration = celebrations[0];

    const dispatch = createEventDispatcher();

    const selectBorder = (borderSrc) => {
        selectedBorderImage = new Image();
        selectedBorderImage.src = borderSrc;
        // selectedBorderImage.onload = () => {
        //     drawCanvas();
        // };
        // selectedBorderImage.onerror = () => {
        //     console.error("Failed to load the border image:", borderSrc);
        // };
        dispatch("selectBorder", {
            selection: selectedBorderImage,
        });
    };
</script>

<main>
    <div class="border-selection">
        <h2>2. Choose Border</h2>

        <Select
            options={celebrations}
            display_func={(o) => o.title}
            bind:value={selectedCelebration}
        />

        <div class="border-examples">
            {#each selectedCelebration.borders as border, i}
                <button type="button" on:click={() => selectBorder(border.src)}>
                    <img
                        src={border.src}
                        alt={border.src}
                    />
                </button>
            {/each}
        </div>

        <div class="celebration-description">
            <SvelteMarkdown source={selectedCelebration.description} options={{breaks:true}} />
        </div>
    </div>
</main>

<style>

    .border-selection {
        background: linear-gradient(135deg, #a8dff3, #dcf3fb);
        border-radius: 10px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
        padding: 10px;
    }

    button {
        cursor: pointer;
        margin: 10px;
        padding: 0;
        border: 2px solid #0071cf;
        transition: border-color 0.3s ease;
        background-image: url("/placeholder.png");
        background-size: 100%;
    }

    button:hover {
        border-color: #cc27b1;
    }

    img {
        max-width: 120px;
        max-height: 120px;
    }

    .celebration-description {
        font-size: large;
    }


</style>
